export const CLASSIFIED_UPDATING = 'CLASSIFIED_UPDATING'
export const CLASSIFIED_UPDATE_SUCCESS = 'CLASSIFIED_UPDATE_SUCCESS'
export const CLASSIFIED_UPDATE_ERROR = 'CLASSIFIED_UPDATE_ERROR'

export const CLASSIFIED_DELETING = 'CLASSIFIED_DELETING'
export const CLASSIFIED_DELETE_SUCCESS = 'CLASSIFIED_DELETE_SUCCESS'
export const CLASSIFIED_DELETE_ERROR = 'CLASSIFIED_DELETE_ERROR'
